import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { Editor } from "react-draft-wysiwyg";
// import { convertFromRaw, convertToRaw } from 'draft-js';
import "./wysiwyg.css";
// import { EditorState, convertFromRaw, Modifier } from 'draft-js'
// import PropTypes from 'prop-types'

// class CustomOptionSave extends Component {
//   constructor(props) {
//     super(props)
//     this.state = {}
//   }

//   save = () => {
//     const { contentState } = this.props
//     this.props.editAsset(contentState)
//   }

//   render() {
//     const { isUpdating } = this.props
//     return (
//       <div
//         className={isUpdating ? 'save heartbeat' : 'save'}
//         onClick={this.save}
//         style={isUpdating ? { filter: 'drop-shadow(0px 0px 1px #70f6ff)' } : {}}
//       >
//         <span
//           className={isUpdating ? 'rotate-save' : ''}
//           role="img"
//           aria-label="fuego"
//         >
//           {/* 🔥 */}
//         </span>{' '}
//         Guardar{' '}
//         <span
//           className={isUpdating ? 'rotate-save' : ''}
//           role="img"
//           aria-label="fuego"
//         >
//           {/* <img style={{marginLeft: '3px'}} src="/images/img_v2/icon-loader.png" alt=""/> */}
//         </span>
//       </div>
//     )
//   }
// }

export class TextEditorDart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contentState: this.props.contentState,
      contentStateOld: this.props.contentState,
      isToolbar: true,
      cssCustom: {
        borderTopLeftMain: "8px",
        borderTopRightMain: "8px",
        borderTopMain: "#0096d6"
      },
      optionsCss: new Map([
        ["COLOR_HIDDEN", "#0E2A45"],
        ["COLOR_SHOW", "#0096d6"],
        ["BORDER_HIDDEN", "0px"],
        ["BORDER_SHOW", "8px"]
      ])
    };
  }

  focusEditor = () => {
    if (this.editorref) this.editorref.focusEditor();
  };

  onContentStateChange = contentState => {
    this.setState({
      contentState
    });
  };

  closeEditor = event => {
    const { contentState, contentStateOld, optionsCss } = this.state;
    // para evitar cierre de modal de hipervinculo en evento onBlur
    if (
      event.target.classList[0] !== "rdw-link-modal-input" &&
      event.target.id !== "openLinkInNewWindow"
    ) {
      this.setState(state => ({
        isToolbar: true,
        cssCustom: {
          ...state.cssCustom,
          borderTopLeftMain: optionsCss.get("BORDER_SHOW"),
          borderTopRightMain: optionsCss.get("BORDER_SHOW"),
          borderTopMain: optionsCss.get("COLOR_SHOW")
        }
      }));

      if (this.editorref) this.props.changeFocusDescription(false);
      if (JSON.stringify(contentStateOld) !== JSON.stringify(contentState)) {
        this.props.editAsset(contentState);
        this.setState({ contentStateOld: contentState });
      }
    }
  };

  showToolbar = () => {
    this.setState(({ optionsCss, cssCustom }) => ({
      isToolbar: true,
      cssCustom: {
        ...cssCustom,
        borderTopLeftMain: optionsCss.get("BORDER_HIDDEN"),
        borderTopRightMain: optionsCss.get("BORDER_HIDDEN"),
        borderTopMain: optionsCss.get("COLOR_HIDDEN")
      }
    }));
    this.setState({ isToolbar: false });
  };

  componentDidUpdate() {
    const hiperlinkElement = document.querySelector(".rdw-link-modal-btn");
    if (hiperlinkElement && !hiperlinkElement.disabled)
      hiperlinkElement.style.background = "#0096D6";
    else if (hiperlinkElement && hiperlinkElement.disabled)
      hiperlinkElement.style.background = "#808080";
  }
  render() {
    const toolbar = {
      items: ["CreateLink"],
      options: ["inline", "fontSize", "fontFamily", "link"],
      inline: {
        options: ["bold", "italic", "underline", "strikethrough"],
        bold: {
          icon:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDE4MS4zOTUgMTgxLjM5NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSw4LjUyNjUxMjgyOTEyMTIwMmUtMTQsNy4xMDU0MjczNTc2MDEwMDJlLTE0KSI+CiAgPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im0yMC42MTgsMTgxLjM5NXYtMTgxLjM5NWg2Mi4yOTNjMjIuNTA2LDAgNDAuMDc0LDQuMTc0IDUyLjY5OSwxMi41MjEgMTIuNjIzLDguMzQ2IDE4LjkzNiwyMC43ODUgMTguOTM2LDM3LjMxMyAwLDguNjM5LTIuMDMzLDE2LjMxOC02LjEwNCwyMy4wNDktNC4wNyw2LjcyOS0xMC4zNCwxMS43OTUtMTguODEzLDE1LjE5OSAxMC42MzEsMi40MDggMTguNDc5LDcuMjQ2IDIzLjU0NywxNC41MTQgNS4wNjQsNy4yNjggNy42LDE1LjYzNyA3LjYsMjUuMTA0IDAsMTcuNjkxLTUuOTM5LDMxLjA2NC0xNy44MTQsNDAuMTE1LTExLjg3OSw5LjA1NS0yOC45MDQsMTMuNTgtNTEuMDgyLDEzLjU4aC03MS4yNjJ6bTQyLjIzNS0xMDUuNzcyaDIwLjkzYzkuNTUxLTAuMTY2IDE2LjY5NS0yLjAxNCAyMS40My01LjU0NSA0LjczNC0zLjUyOSA3LjEwMi04LjY5OSA3LjEwMi0xNS41MSAwLTcuNzI1LTIuNDEtMTMuMzUtNy4yMjUtMTYuODgxLTQuODItMy41MjktMTIuMjExLTUuMjk1LTIyLjE3OC01LjI5NWgtMjAuMDU5djQzLjIzMXptMCwyNy45MDh2NDUuNDczaDI5LjAyN2M4Ljk3MSwwIDE1LjY5OS0xLjc2NiAyMC4xODQtNS4yOTcgNC40ODQtMy41MjkgNi43MjktOC45NDcgNi43MjktMTYuMjU2IDAtNy44OTEtMS45MzItMTMuODUtNS43OTUtMTcuODc5LTMuODYxLTQuMDI3LTEwLjExMS02LjA0MS0xOC43NDgtNi4wNDFoLTMxLjM5N3oiIGZpbGw9IiMwMDk2ZDYiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIHN0eWxlPSIiIGNsYXNzPSIiPjwvcGF0aD4KICA8L2c+CjwvZz48L3N2Zz4="
        },
        italic: {
          icon:
            "data:image/svg+xml;base64,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"
        },
        underline: {
          icon:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDM4NCAzODQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoJPGc+CgkJPGc+CgkJCTxwYXRoIGQ9Ik0xOTIsMjk4LjY2N2M3MC43MiwwLDEyOC01Ny4yOCwxMjgtMTI4VjBoLTUzLjMzM3YxNzAuNjY3YzAsNDEuMjgtMzMuMzg3LDc0LjY2Ny03NC42NjcsNzQuNjY3ICAgICBzLTc0LjY2Ny0zMy4zODctNzQuNjY3LTc0LjY2N1YwSDY0djE3MC42NjdDNjQsMjQxLjM4NywxMjEuMjgsMjk4LjY2NywxOTIsMjk4LjY2N3oiIGZpbGw9IiMwMDk2ZDYiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIHN0eWxlPSIiIGNsYXNzPSIiPjwvcGF0aD4KCQkJPHJlY3QgeD0iNDIuNjY3IiB5PSIzNDEuMzMzIiB3aWR0aD0iMjk4LjY2NyIgaGVpZ2h0PSI0Mi42NjciIGZpbGw9IiMwMDk2ZDYiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIHN0eWxlPSIiIGNsYXNzPSIiPjwvcmVjdD4KCQk8L2c+Cgk8L2c+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPC9nPjwvc3ZnPg=="
        },
        strikethrough: {
          icon:
            "data:image/svg+xml;base64,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"
        }
      },
      link: {
        options: ["link"],
        link: {
          icon:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABIklEQVRIie2TO07DQBRFzxtHNNkBK8BpSU8WQMQKsgCMKKgigVIQESk0bkDT81lABNSBnrRxWAErCE0k/ChsKx4TROIKJJ9mNL/77purgYqKP484s+vpAUZOgCZQd/aChnvWRlrQ+gBeUQk58h+zRZO7MMTICNj7Jr4edaCF6AN2NnA7SJyPgAVKj9jcc7zzvpH81ds2XtwB+sAWIm0O/afM/Qs2UmzULeHcxUbdRGs6Bqily7sAeNwWDhffeTX5fFRvEBmCNCGfAcDCuEGWwdS8rBQsO5gArfQNL1c6W5u4k4wyWRZQCRFtAX1sBJ/mrnTIqudpAyHk/4GdDUBPfxT4/R/kuSBo9CCfQeCfIdIGfQbmG7lPmIOMgf1MvKLin/AFnkBXuZluDSYAAAAASUVORK5CYII="
        }
      }
    };

    const { intl } = this.props;
    const { contentState, isToolbar, cssCustom } = this.state;
    const editorLabels = {
      "components.controls.link.linkTitle": intl.formatMessage({
        id: "link_title"
      }),
      "components.controls.link.linkTarget": intl.formatMessage({
        id: "link_target"
      }),
      "components.controls.link.linkTargetOption": intl.formatMessage({
        id: "link_target_option"
      }),
      "components.controls.link.link": intl.formatMessage({ id: "add" }),
      "components.controls.link.unlink": intl.formatMessage({
        id: "cancel_button"
      })
    };

    return (
      <div>
        <Editor
          ref={ip => (this.editorref = ip)}
          initialContentState={contentState}
          toolbar={toolbar}
          localization={{ locale: intl.locale, translations: editorLabels }}
          onContentStateChange={this.onContentStateChange}
          onBlur={this.closeEditor}
          placeholder={intl.formatMessage({
            id: "add_description"
          })}
          toolbarHidden={isToolbar}
          onFocus={this.showToolbar}
          editorStyle={{
            "--color-border-toolbar": cssCustom.borderTopMain,
            "--border-top-left": cssCustom.borderTopLeftMain,
            "--border-top-right": cssCustom.borderTopRightMain
          }}
          // toolbarCustomButtons={[
          //   <CustomOptionSave
          //     editAsset={this.props.editAsset}
          //     contentState={contentState}
          //     isUpdating={isUpdating}
          //   />,
          // ]}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    workclient: state.client.workclient
  };
};

const mapDispatchToProps = {
  // setEditAsset,
  // test: 'test',
};

// const mapDispatchToProps = (dispatch) => ({
//   editAsset: (workclient, asset) =>
//     dispatch(setEditRootAsset(workclient, asset)),
// })

// export default injectIntl(
//   connect(mapStateToProps, mapDispatchToProps)(TextEditorDart)
// )

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(TextEditorDart))
);
